import React from 'react';
import ProtectedRoute from './components/HomePage';

const App: React.FC = () => {
  return (
    <div className="App">
      <ProtectedRoute />
    </div>
  );
};

export default App;

